import { Box, Button, Card, CardContent, CardHeader, TextField } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";
import SuccessMessage from "./SuccessMessage";

const RequestReport = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [open, setOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  function requestReport() {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "email": email,
      "password": password
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      // redirect: 'follow'
    };
    setLoading(true);
    fetch("https://r78can1f37.execute-api.ap-south-1.amazonaws.com/prod/cams_cas", requestOptions)
      .then(response => response.json())
      .then(result => {
        setMessage(result.message);
        setOpen(true);
        setLoading(false);
      })
      .catch(error => {
        toast({ type: 'error', message: 'Sorry! some error occured!. Please try again after some time.' });
        setLoading(false);
      });
  }
  function disabled() {
    return !email || !password || isLoading;
  }


  return <Card>
    <CardHeader title="Step 1: Generate report"
      subheader="Your report will be generated &amp; sent to email." />
    <CardContent>
      <form>
        <Box>
          <TextField
            label="Provide the email registered with AMCs"
            fullWidth
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </Box>
        <Box mt={3}>
          <TextField
            label="Some password for your report"
            helperText="(min 6 characters with 3 numbers in it)"
            fullWidth
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
        </Box>
        <Box mt={3}>
          <Button disabled={disabled()} onClick={requestReport} variant="contained" fullWidth>
            {isLoading ? 'Processing...' : 'Send CAS Report to my email'}
          </Button>
        </Box>
      </form>
    </CardContent>
    <SuccessMessage open={open} setOpen={setOpen} message={message || ''} />
  </Card>
}

export default RequestReport;